(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/match-init-box/assets/javascripts/views/init-box.js') >= 0) return;  svs.modules.push('/components/sport/match-init-box/assets/javascripts/views/init-box.js'); 'use strict';

(function(Backbone, _, svs) {

  svs.sport.matchInitBox.views.InitBox = Backbone.View.extend({
    initialize: function() {
      this.model = new svs.sport.matchInitBox.models.InitBox();
    },

    render: function() {
      this.$el.html(
        svs.sport.match_init_box.templates.init_box(this.model.toJSON())
      );
      return this;
    },

    onDestroy: function() {
    }
  });
})(Backbone, _, svs);

 })(window);